export enum OpportunityInitialsStatusType {
  WAITING = '60a438fd-eecd-4348-9e72-81b5b65c50c4',
  APPROVED = '20e9071b-570b-4e43-b079-ee3710b21aae',
  DENIED = '75b44ba8-9535-48d0-a521-6a718f5f28ed'
}
